import React from "react";

interface TextAreaFieldProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  touched?: boolean;
  containerClassName?: string;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
  error,
  touched,
  containerClassName = "",
  className = "",
  style,
  ...props
}) => {
  return (
    <div className={containerClassName}>
      <textarea
        {...props}
        className={`w-full px-3 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-[#BCBCBF] placeholder:font-normal placeholder:text-[15px] placeholder:leading-[100%] font-poppins text-base md:text-sm ${className}`}
        style={style}
      />
      {touched && error && (
        <div className="pt-1 pl-1 text-sm text-red-600">{error}</div>
      )}
    </div>
  );
};

export default TextAreaField;
